import { render } from "./BankAccountCreate.vue?vue&type=template&id=7d0dc02d"
import script from "./BankAccountCreate.vue?vue&type=script&lang=js"
export * from "./BankAccountCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__